import { PennyProvider } from '@melio/penny';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { SignUpPage, LoginPage, LogoutPage, MFAChallengePage, ForgotPasswordPage, SsoCallbackPage, EnvironmentRibbon } from './components';
import { AuthLayout } from './components/AuthLayout';
import { VariantProvider } from './contexts/VariantContext';
import { melioTheme } from './theme/melioTheme';

import './styles/base.css';

const DefaultRedirect = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const variant = searchParams.get('variant');
  const defaultPath = variant ? '/create-account' : '/sign-in';
  return <Navigate to={`${defaultPath}${location.search}`} replace />;
};

export const App = () => {
  return (
    <PennyProvider theme={melioTheme}>
      <BrowserRouter>
        <VariantProvider>
          <EnvironmentRibbon />
          <Routes>
            <Route path="/sso/callback" element={<SsoCallbackPage />} />
            <Route element={<AuthLayout />}>
              <Route path="/create-account" element={<SignUpPage />} />
              <Route path="/sign-in" element={<LoginPage />} />
              <Route path="/logout" element={<LogoutPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              {/* MFA routes - challenge is for login flow, future: /mfa/setup, /mfa/manage */}
              <Route path="/mfa/challenge" element={<MFAChallengePage />} />
              <Route path="*" element={<DefaultRedirect />} />
            </Route>
          </Routes>
        </VariantProvider>
      </BrowserRouter>
    </PennyProvider>
  );
};
